import { useDispatch, useSelector } from '@redux';
import { Layout } from 'antd';
import Header from 'layout/PrivateLayout/Header';
import Sidebar from 'layout/PrivateLayout/Sidebar';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PrivateLayoutWrapper, { CustomLayoutProps } from './styles';
import {
  getAddress,
  getAllLocations,
  getChainStores,
  getConfigPartner,
} from '@redux/config/actions';
import ModalRoute from 'routes/ModalRoute';
import { getCurrentUser } from '@redux/auth/actions';
// import { getVendorFfmSummary } from '@redux/vendorFfms/actions';
import { DynamicObjectType } from 'types/commons';
import { checkRole, newCheckRole } from 'utils/tools';
import { getAllPartners } from '@redux/partners/actions';

export default function PrivateLayout({
  children,
  title,
  isCreateModal,
  customCreateBtn,
  customRootPath,
  hiddenCreateButton,
  isFull,
  checkRoles,
}: CustomLayoutProps) {
  const dispatch = useDispatch();
  const token = useSelector<string>((state) => state.auth.token);
  const user = useSelector<DynamicObjectType>((state) => state.auth.data);

  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      // dispatch(getVendorFfmSummary());
      dispatch(
        getCurrentUser({
          data: {},
        }),
      );
      dispatch(getAddress());
      dispatch(
        getAllLocations({
          data: {
            filters: [],
          },
        }),
      );
    }

    // eslint-disable-next-line
  }, [token]);

  useEffect(() => {
    if (!token) {
      navigate('/login');
    } else {
      if (user?.role) {
        if (
          checkRole(
            'chain-stores',
            user?.rolePermission,
            'GET',
            user?.role === 'bypass',
          )
        ) {
          dispatch(getChainStores({ data: {} }));
        }
        if (
          checkRole(
            'partners',
            user?.rolePermission,
            'GET',
            user?.role === 'bypass',
          )
        ) {
          dispatch(getConfigPartner());
          dispatch(
            getAllPartners({
              data: {
                filters: [
                  {
                    condition: 'and',
                    key: 'isDelivery',
                    operator: 'is',
                    value: true,
                  },
                ],
                pageSize: 50,
              },
              options: {
                isRefresh: true,
              },
            }),
          );
        }
      }
    }
  }, [token]);

  useEffect(() => {
    if (
      user?.roles &&
      user?.roles.length &&
      checkRoles &&
      !newCheckRole(
        checkRoles?.endpoint,
        checkRoles?.method,
        user?.roles,
        user?.isSuperUser,
      )
    ) {
      navigate('/');
    }
  }, [checkRoles, user]);

  return isFull ? (
    <Layout>
      <Layout.Content>{children}</Layout.Content>
      <ModalRoute />
    </Layout>
  ) : (
    <PrivateLayoutWrapper>
      <Sidebar />
      <Layout>
        <Header
          title={title}
          isCreateModal={isCreateModal}
          customCreateBtn={customCreateBtn}
          customRootPath={customRootPath}
          hiddenCreateButton={hiddenCreateButton}
          checkRoles={checkRoles}
        />
        <Layout.Content className="layout-content">
          <div className="layout-content-wrap">{children}</div>
        </Layout.Content>
      </Layout>
      <ModalRoute />
    </PrivateLayoutWrapper>
  );
}
